import { numberFormatters } from "common/number-formatters";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
import { NumberFormatKind } from "common/types";
export const valueFormatter = (value, valueFormat, currency) => {
    switch (valueFormat) {
        case ChartSelectValueFormatKind.amount:
            return numberFormatters(value, NumberFormatKind.currency, { currency });
        case ChartSelectValueFormatKind.multiple:
            return numberFormatters(value, NumberFormatKind.multiple, { maximumFractionDigits: 2 });
        case ChartSelectValueFormatKind.percent:
            return numberFormatters(value, NumberFormatKind.percent, { maximumSignificantDigits: 3 });
        default:
            return value;
    }
};
export const formatTooltipData = (datapoint, selectedDropDownProps) => datapoint.tooltips?.map(([k, v]) => {
    const label = k[0].startsWith("$") ? selectedDropDownProps[parseInt(k.slice(1), 10)]?.displayName || "" : k;
    const value = typeof v === "object"
        ? valueFormatter(v.amount, ChartSelectValueFormatKind.amount, v.currency)
        : valueFormatter(v, selectedDropDownProps[parseInt(k.slice(1), 10)]?.valueFormat ?? "");
    return [label, value];
});
